/* eslint-disable typescript-enum/no-enum */

/**
 * Live preferences selected for usage/loading within application.
 */
export enum EUserPreference {
  // Current context preferences:
  ONBOARDING_RTMP = 'rtmpobtp',
  ONBOARDING_RTC = 'slobtp',
  ONBOARDING_RTC_BOKEH = 'slnwbrdnbh',
  ONBOARDING_RTC_SIMULIVE = 'sltrschld',
  PUBLISH_TO_SOCIAL = 'psaa',
  // Owner context preferences:
  HIDE_TEMPLATES_TAB = 'slhdtmtb',
  EXTENDED_STREAM_WITH_DVR = 'ldful',
  EXTENDED_STREAM_WITH_SIMULCAST = 'lsful',
  EXPLICIT_LIVE_GUESTS_API_MANAGEMENT = 'lgam',
  EXPLICIT_LIVE_MEDIA_API_MANAGEMENT = 'lmam',
}

export enum EPendoToursIds {
  ONBOARDING_RTC_BOKEH_PENDO_ID = 'tFycqmahlV58D6KZDhjm0w_gaBY',
  ONBOARDING_RTC_REGULAR_PENDO_ID = 'V75Ih5C6kJnxUyy47ADbUFzKGeE',
  ONBOARDING_RTC_SIMULIVE_PENDO_ID = 'z9Na2wCKV8eC4CxpAdxFkZmGkd8',
  ONBOARDING_RTMP_REGULAR_PENDO_ID = 'BnGM1gi_qj1jw4Da363WY3oLOVs',
}

export enum EPendoSurveysIds {
  RTC_MODE_CSAT = 'kC9rIuUAUsRzwKLJrRig3988KTk',
  RTMP_MODE_CSAT = 'YcC0ow-Tz2Pm7UKOtn5d6RSWewA',
}
